import { render, staticRenderFns } from "./Pathologist.vue?vue&type=template&id=46519da1&scoped=true&"
import script from "./Pathologist.vue?vue&type=script&lang=js&"
export * from "./Pathologist.vue?vue&type=script&lang=js&"
import style0 from "./Pathologist.vue?vue&type=style&index=0&id=46519da1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46519da1",
  null
  
)

export default component.exports